import { keyBy } from 'lodash/fp';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { DataTestId, TextKey } from '@mews-distributor/common';
import { PricingMode } from '@mews/enums';
import { LocalizedText } from '@mews/framework';

import { getLanguageCode } from '../../../modules/app/selectors';
import { localizeCurrencyValue } from '../../../modules/globalization/selectors';
import { ApplicationState } from '../../../types';
import {
    getImmediatelySettledTotalAmountWithPreauthorizations,
    isImmediatelySettledTotalAmountFullWithPreauthorizations,
    isImmediatelySettledTotalAmountPositiveWithPreauthorizations,
} from '../../../views/checkout/data/viewSelectors';

interface BaseOrderRateGroupDescription {
    settlementTotalAmountString: string;
    isFullImmediateSettlement: boolean;
    isImmediatelySettled: boolean;
}
const BaseOrderRateGroupDescription = ({
    settlementTotalAmountString,
    isFullImmediateSettlement,
    isImmediatelySettled,
}: BaseOrderRateGroupDescription) => {
    if (!isImmediatelySettled) {
        return (
            <LocalizedText
                data-test-id={DataTestId.RateSettlementRuleDescriptionLater}
                textKey={TextKey.YouWillPayLater}
            />
        );
    }

    if (isFullImmediateSettlement) {
        return (
            <LocalizedText data-test-id={DataTestId.RateSettlementRuleDescriptionNow} textKey={TextKey.YouWillPayNow} />
        );
    }

    return (
        <LocalizedText
            data-test-id={DataTestId.RateSettlementRuleDescriptionAmount}
            textKey={TextKey.YouWillPayAmount}
            substitutes={{
                amount: settlementTotalAmountString,
            }}
        />
    );
};

export const OrderRateGroupDescription = connect(
    createStructuredSelector<
        ApplicationState,
        { settlementTotalAmountString: string; isFullImmediateSettlement: boolean; isImmediatelySettled: boolean }
    >({
        settlementTotalAmountString: (state) => {
            if (!isImmediatelySettledTotalAmountPositiveWithPreauthorizations(state)) {
                return '';
            }

            const settlementTotalAmount = getImmediatelySettledTotalAmountWithPreauthorizations(state);

            return localizeCurrencyValue(state, {
                // @ts-expect-error $TSFixMeError: Type 'string | undefined' is not assignable to type 'string'.
                languageCode: getLanguageCode(state),
                pricingMode: PricingMode.Gross,
                currencyValue: keyBy('currency', [settlementTotalAmount]),
                optionalCurrencyCode: settlementTotalAmount.currency,
            });
        },

        isFullImmediateSettlement: isImmediatelySettledTotalAmountFullWithPreauthorizations,
        isImmediatelySettled: isImmediatelySettledTotalAmountPositiveWithPreauthorizations,
    })
)(BaseOrderRateGroupDescription);
